import { ProductRegistration } from 'domain/product/interfaces';

export const getProductRegistration = (
	productRegistrations: ProductRegistration[],
	productId?: string,
) =>
	productRegistrations.find(
		(app) => app.productId.toLowerCase() === productId?.toLowerCase(),
	);
